/**
 * Auswahl eines Benutzers (z. B. zustaendiger Aussendienst).
 *
 * Nutzt die leichte Namensliste /api/users/options - dafuer reicht die
 * Anmeldung, die Benutzerverwaltung bleibt geschuetzt. Deaktivierte
 * Benutzer erscheinen nur, wenn sie bereits zugeordnet sind: Alte
 * Zuordnungen bleiben lesbar, neue entstehen nicht mehr.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';
import { SearchSelect } from './SearchSelect';

type UserOption = { id: string; displayName: string; active: boolean };

export function UserSelect({
  value,
  onChange,
  emptyLabel = 'Ohne Zuordnung',
  placeholder = 'Namen tippen …',
  disabled,
  invalid,
}: {
  value: string;
  onChange: (value: string) => void;
  emptyLabel?: string;
  placeholder?: string;
  disabled?: boolean;
  invalid?: boolean;
}) {
  const { data } = useQuery({
    queryKey: ['user-options'],
    queryFn: () => api.get<{ users: UserOption[] }>('/api/users/options'),
    staleTime: 5 * 60_000,
  });

  const options = (data?.users ?? [])
    .filter((user) => user.active || user.id === value)
    .map((user) => ({ value: user.id, label: user.displayName }));

  return (
    <SearchSelect
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      emptyLabel={emptyLabel}
      disabled={disabled}
      invalid={invalid}
    />
  );
}
